import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { login, errorCode } from 'services/auth.service'
import AuthLayout, { authInputClass, authLabelClass, authButtonClass } from 'components/AuthLayout'
import { useI18n, apiError } from 'i18n'

const Login = () => {
  const navigate = useNavigate()
  const { t } = useI18n()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)

  const onSubmit = async (event) => {
    event.preventDefault()
    setBusy(true)
    try {
      await login(email, password)
      navigate('/', { replace: true })
    } catch (error) {
      if (errorCode(error) === 'EMAIL_NOT_VERIFIED') {
        // The API just emailed a fresh code.
        navigate(`/verify-email?email=${encodeURIComponent(email.trim())}`, { state: { resent: true } })
        return
      }
      toast.error(apiError(error, t('login.failed')))
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout
      subtitle={t('login.subtitle')}
      onSubmit={onSubmit}
      footer={<>{t('login.noAccount')} <Link to='/signup' className='font-semibold text-accent hover:underline'>{t('login.startTrial')}</Link></>}
    >
      <label htmlFor='login-email' className={authLabelClass}>{t('login.email')}</label>
      <input id='login-email' type='email' autoComplete='email' value={email} onChange={(e) => setEmail(e.target.value)} required
        className={`mb-4 ${authInputClass}`} />
      <div className='mb-1 flex items-baseline justify-between gap-2'>
        <label htmlFor='login-password' className='text-sm font-medium text-slate-600'>{t('login.password')}</label>
        <Link to={`/forgot-password${email.trim() ? `?email=${encodeURIComponent(email.trim())}` : ''}`}
          className='text-xs font-semibold text-brand hover:underline'>{t('login.forgot')}</Link>
      </div>
      <input id='login-password' type='password' autoComplete='current-password' value={password} onChange={(e) => setPassword(e.target.value)} required
        className={`mb-6 ${authInputClass}`} />
      <button type='submit' disabled={busy} className={authButtonClass}>
        {busy ? t('login.submitting') : t('login.submit')}
      </button>
    </AuthLayout>
  )
}

export default Login
